export const zh = {
  // TopBarHeader
  '连接状态': '连接状态',
  'MCU连接状态': 'MCU连接状态',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: 未连接',
  'Connected': '已连接',
  'Disconnected': '未连接',
  '输出天线：': '输出天线：',
  '手动选择': '手动选择',
  '自动选择': '自动选择',
  '触发模式：': '触发模式：',
  '接收状态': '接收状态',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': '输入功率触发',
  '时间': '时间',
  '系统同步': '系统同步',
  '报警信息': '报警信息',

  // TopBarBottom
  '输入天线1': '输入天线1',
  '输入天线2': '输入天线2',
  '输入天线衰减器': '输入天线衰减器',
  '输入衰减器': '输入衰减器',
  '功放': '功放',
  '天调': '天调',
  '关闭': '关闭',
  '开启': '开启',
  '调谐中': '调谐中',
  '调谐失败': '调谐失败',
  '输出天线1': '输出天线1',
  '输出天线2': '输出天线2',
  '输出天线3': '输出天线3',
  '输出天线4': '输出天线4',

  // TopBarMiddle
  '频段未获取': '频段未获取',
  'Counter': '计数器',
  'Hamlib': 'Hamlib',
  '滤波器：': '滤波器：',
  '频段：': '频段：',
  '输入': '输入',
  '输出': '输出',
  '反向功率': '反向功率',
  '驻波': '驻波',
  '电压:': '电压:',
  '电流:': '电流:',
  '功率:': '功率:',
  '温度:': '温度:'
};
